<template>
  <div ref="readForm" v-loading="statusDialogLoading">
    <table :class="$style['status-dialog']">
      <pt-form-list-item label="预约状态变更：" :required="true">
        <wt-radio v-model="formValue.statusApi" :radios="changeStatusMode" data-vv-as="预约状态变更"
            name="shippingModes"  v-validate="'required'"></wt-radio>
      </pt-form-list-item>
    </table>
    <div class="button-div">
      <el-button type="primary"  @click="submit">确定</el-button>
      <el-button type="primary" @click="cancel" plain>取消</el-button>
    </div>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { changeStatusMode } from 'json/sign'
export default {
  name: 'status-dialog',
  mixins: [formMixins],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      formValue: {},
      changeStatusMode: changeStatusMode,
      statusDialogLoading: false
    }
  },
  watch: {
    rowData: {
      handler: function (val) {
        if (this.changeStatusMode.length > 2) {
          this.changeStatusMode.shift()
        }
        if (val.workflowStatus === 'UNCONFIRMED') {
          this.changeStatusMode.unshift({ label: '已确认', value: 'confirmRegistration' })
        } else if (val.workflowStatus === 'CONFIRMED') {
          this.changeStatusMode.unshift({ label: '已解读', value: 'reportInterpreted' })
        }
        console.log(this.changeStatusMode)
        this.formValue = {
          ...val
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    submit () {
      this.validate().then(formValue => {
        this.statusDialogLoading = true
        if (formValue.statusApi === 'reportInterpreted' && !(formValue.unscrambleDetail && formValue.unscrambleDetail.content)) {
          this.$message.error('请录入解读详情')
          this.statusDialogLoading = false
        } else if (formValue.statusApi === 'reportInterpreted' && !formValue.repurchaseIntention) {
          this.$message.error('请录入复购意向')
          this.statusDialogLoading = false
        } else {
          this.$store.dispatch(formValue.statusApi, formValue.id).then(res => {
            this.$message.success('预约解读变更状态成功')
            this.statusDialogLoading = false
            this.$emit('changeStatusCancel')
          }).catch(err => {
            this.$message.error(err || '预约解读变更状态失败')
            this.statusDialogLoading = false
          })
        }
      })
    },
    cancel () {
      this.$emit('changeStatusCancel')
    }
  }
}
</script>

<style module lang="less">
.status-dialog{
   padding: 0 20px;
}
</style>
